import React, { useEffect,  useState } from "react";
import { Form, Formik } from "formik";
import "./patient-create-form.scss";
import FormInfo from "./form-info";
import { patientCreate } from "../../../service/api/patient-api";

const PatientCreateForm = ({
  selectedPatientInfo,
  isNewUser,
  setSinglePatientInfo,
  setIsNewUser,
}) => {
  const [info, setInfo] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (values, { resetForm }) => {
    values = info;
    setIsSubmitting(true);
    await patientCreate(values)
      .then((res) => {
        if (res.status === 200) {
          resetForm();
          setIsNewUser(false);
          setIsSubmitting(false);
          setSinglePatientInfo(res?.data)
        }
      })
      .catch((error) => {
        setIsSubmitting(false);
        console.log(error);
      });
  };
  const setInfoFun = (key, value) => {
    let temp = { ...info };
    setInfo({ ...temp, [key]: value });
  };
  useEffect(() => {
    if (selectedPatientInfo?.name) setInfo(selectedPatientInfo);
    else {
      setInfo({});
    }
  }, [selectedPatientInfo?.name]);

  return (
    <Formik
      initialValues={{
        name: "",
        phone: "",
        email: "",
        age: "",
        gender: "",
        dob: "",
      }}
      onSubmit={onSubmit}
    >
      {(formik) => (
        <div className="patient-create-form-section">
          <Form
            action=""
            id=""
            className="custom-form input-section"
            encType="multipart/form-data"
          >
            <div className="row">
              <div className="col-6">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Name<span className="text-danger">*</span>
                </label>
                <input
                  required
                  className="form-control input"
                  autoComplete="off"
                  type="text"
                  id="name"
                  name="name"
                  value={info?.name || ""}
                  placeholder="Enter Name"
                  //   defaultValue={info?.name}
                  onChange={(e) => {
                    setInfoFun("name", e.target.value);
                  }}
                />
                <br />
              </div>

              <div className="col-6">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Phone Number{" "}
                </label>
                <input
                  className="form-control input"
                  autoComplete="off"
                  pattern="(^(01){1}[3-9]{1}\d{8})$"
                  type="text"
                  id="phone"
                  name="phone"
                  placeholder="Enter Phone Number"
                  value={info.phone || ""}
                  onChange={(e) => {
                    setInfoFun("phone", e.target.value);
                  }}
                />
                <br />
                {/* <ErrorMessage name='firstName'></ErrorMessage> */}
              </div>

              <div className="col-6">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Email
                </label>
                <input
                  className="form-control input"
                  autoComplete="off"
                  type="email"
                  id="email"
                  name="email"
                  placeholder="Enter Email"
                  value={info?.email || ""}
                  onChange={(e) => {
                    setInfoFun("email", e.target.value);
                  }}
                />
                <br />
                {/* <ErrorMessage name='firstName'></ErrorMessage> */}
              </div>

              <div className="col-6">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Age
                </label>
                <input
                  className="form-control input"
                  autoComplete="off"
                  type="string"
                  id="age"
                  name="age"
                  placeholder="Enter age"
                  value={info?.age || ""}
                  onChange={(e) => {
                    setInfoFun("age", e.target.value);
                  }}
                />
              </div>

              <div className="col-6">
                <label htmlFor="exampleInputEmail1" className="form-label">
                  Date of birth<span className="text-danger">*</span>
                </label>
                <input
                  required
                  className="form-control input"
                  autoComplete="off"
                  type="date"
                  id="dob"
                  name="dob"
                  placeholder="Enter appointmentDate"
                  value={info?.dob?.slice(0, 10) || ""}
                  onChange={(e) => {
                    setInfoFun("dob", e.target.value);
                  }}
                />
                <br />
              </div>

              <div className="col-6 ">
                <div className="">
                  <label htmlFor="exampleInputEmail1" className="form-label">
                    Gender<span className="text-danger">*</span>
                  </label>
                  <div role="group" aria-labelledby="my-radio-group">
                    <label className="mx-3">
                      <input
                        checked={
                          info?.gender?.toLowerCase() === "male" ? true : false
                        }
                        type="radio"
                        name="gender"
                        value="Male"
                        onClick={() => {
                          setInfoFun("gender", "Male");
                        }}
                      />
                      <span className="ml-1">Male</span>
                    </label>
                    <label>
                      <input
                        className="asdfg"
                        checked={
                          info?.gender?.toLowerCase() === "female" ? true : false
                        }
                        type="radio"
                        name="gender"
                        value="Female"
                        onClick={() => {
                          setInfoFun("gender", "Female");
                        }}
                      />
                      <span className="ml-1">Female</span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-12  text-center mt-3">
                <button
                  type="submit"
                  className="btn submit-button mx-auto w-25"
                  onClick={() => {}}
                  disabled={isNewUser ? false : true }
                >
                  {!isSubmitting?isNewUser? "Add patient" : "Update":""}
                  {isSubmitting && (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  )}
                </button>
              </div>
            </div>
          </Form>
          <div className="details-section">
            <FormInfo info={info}></FormInfo>
          </div>
        </div>
      )}
    </Formik>
  );
};

export default PatientCreateForm;
